import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusStyles = {
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  open: "bg-sky-50 text-sky-800 border-sky-200",
  sent: "bg-sky-50 text-sky-800 border-sky-200",
  overdue: "bg-amber-50 text-amber-900 border-amber-200",
  failed: "bg-rose-50 text-rose-800 border-rose-200",
  payment_failed: "bg-rose-50 text-rose-800 border-rose-200",
  invoice_failed: "bg-rose-50 text-rose-800 border-rose-200",
  duplicate: "bg-slate-100 text-slate-800 border-slate-200",
  missing: "bg-orange-50 text-orange-900 border-orange-200",
  synced: "bg-teal-50 text-teal-900 border-teal-200",
  pending: "bg-zinc-50 text-zinc-800 border-zinc-200",
  new: "bg-indigo-50 text-indigo-900 border-indigo-200",
  active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  inactive: "bg-zinc-50 text-zinc-800 border-zinc-200",
  processed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  invoiced: "bg-teal-50 text-teal-900 border-teal-200",
  critical: "bg-rose-50 text-rose-800 border-rose-200",
  warning: "bg-amber-50 text-amber-900 border-amber-200",
  info: "bg-sky-50 text-sky-800 border-sky-200",
  void: "bg-zinc-50 text-zinc-800 border-zinc-200",
};

const displayLabels = {
  payment_failed: "Payment Failed",
  invoice_failed: "Invoice Failed",
  us_bank_account: "ACH",
  duplicate_transaction: "Duplicate",
  invalid_payload: "Invalid Payload",
  failed_invoice_send: "Invoice Failed",
  stripe_sync_failure: "Sync Failed",
  overdue_invoice: "Overdue",
  missing_monthly_payment: "Missing Payment",
  ach_mismatch: "ACH Mismatch",
  unauthorized_webhook: "Unauthorized",
  failed_payment: "Payment Failed",
};

export default function StatusBadge({ status, className }) {
  if (!status) return null;
  const key = status.toLowerCase().replace(/\s+/g, "_");
  const style = statusStyles[key] || "bg-zinc-50 text-zinc-800 border-zinc-200";
  const label = displayLabels[key] || status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ");

  return (
    <Badge
      variant="outline"
      className={cn("text-xs font-medium px-2 py-0.5 capitalize", style, className)}
    >
      {label}
    </Badge>
  );
}
